import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BusquedaFiltros } from '../_models/busqueda-filtros';
import { Solicitud } from '../_models/solicitud';

@Injectable({
  providedIn: 'root'
})
export class SolicitudBloqueoSarlaftService{
  private rutServicio = AppSettings.rutServiciosAPL + '/api/solicitudes/';

  constructor( private httClient: HttpClient ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as Solicitud[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as Solicitud[] ) );
  }

  obtenerPorId( idLogSincronizacion: string ) {
    return this.httClient.get( this.rutServicio + idLogSincronizacion ).pipe( map( res => res as Solicitud ) );
  }

  /*crear( regCrear: Control ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as Control ) );
  }

  actualizar( regActualizar: Control ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }*/

  buscadorSolicitudesSarlaft( busqueda: BusquedaFiltros ) {
    return this.httClient.post( this.rutServicio + 'buscador', busqueda ).pipe( map( res => {
      const respuesta = res as any;
      const datos = { paginas: respuesta.totalPages, total: respuesta.totalElements, data: respuesta.content as Solicitud[] };
      return datos;
    } ) );
  }
}
